import { type RouterScrollBehavior } from 'vue-router';

const scrollBehavior: RouterScrollBehavior = (to) => {
  if (to.matched.some((match) => match.meta.scrollToTop)) {
    return { left: 0, top: 0 };
  }
};

export default scrollBehavior;
